import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
// import { Edit } from "feather-icons-react/build/IconComponents";

import Table from "../../../../core/pagination/datatable";
import NewCustomer from "./NewCustomer";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Spin, Switch } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import axios from "axios";
import { BASE_CRM_URL } from "../../../components/config/config";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
dayjs.extend(customParseFormat);

const CRMCustomers = () => {
  // const avatarColors = {
  //   Biometric: "#1677ff",
  //   "Biometric Device": "#13c2c2",
  //   "RC Lite": "#52c41a",
  //   "Thermal Printer": "#fa8c16",
  //   "Access Control": "#722ed1",
  //   Default: "#6c757d",
  // };

  const today = new Date().toISOString().split("T")[0];
  const [customerData, setCustomerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCustomer, setShowCustomer] = useState(false);
  const [cardsData, setCardData] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);

  console.log(cardsData, "cardsData......");

  const columns = [
    {
      title: "Company",
      dataIndex: "company",
      sorter: (a, b) => (a.company || "").localeCompare(b.company || ""),
      render: (_, record) => {
        // const initials = record.company
        //   .split(" ")
        //   .slice(0, 2)
        //   .map((word) => word[0])
        //   .join("")
        //   .toUpperCase();

        // const avatarColor =
        //   avatarColors[record.groups?.[0]] || avatarColors.Default;

        return (
          <div className="d-flex align-items-start">
            {/* <div className="position-relative">
              <Avatar
                size={39}
                style={{
                  backgroundColor: avatarColor,
                  fontWeight: 700,
                  fontSize: 17,
                  color: "#fff",
                }}
              >
                {initials}
              </Avatar>

              <span
                className={`position-absolute bottom-0 end-0 border border-white rounded-circle ${
                  record.active ? "bg-success" : "bg-danger"
                }`}
                style={{
                  width: 11,
                  height: 11,
                }}
              />
            </div> */}

            <Link
              to={`/crm/customerinfo/${record.customerId}`}
              className="ms-3"
            >
              <div className="fw-semibold" title={record.company}>
                {record.company?.length > 25
                  ? `${record.company.slice(0, 25)}...`
                  : record.company}
              </div>

              <span title={record.email} className="text-muted">
                <i className="fa-regular fa-envelope me-2 text-secondary"></i>
                {record.email?.length > 20
                  ? `${record.email.slice(0, 20)}...`
                  : record.email || "N/A"}
              </span>
            </Link>
          </div>
        );
      },
    },
    {
      title: "Contact Person",
      dataIndex: "contactName",
      sorter: (a, b) =>
        (a.contactName || "").localeCompare(b.contactName || ""),
      render: (_, record) => (
        <>
          <div title={record.contactName} className="fw-semibold">
            <i className="fa-regular fa-user me-2 text-primary"></i>
            {record.contactName?.length > 25
              ? `${record.contactName.slice(0, 25)}...`
              : record.contactName || "N/A"}
          </div>

          <span title={record.title} className="text-muted">
            <i className="fa-solid fa-briefcase me-2"></i>
            {record.title?.length > 25
              ? `${record.title.slice(0, 25)}...`
              : record.title || "N/A"}
          </span>
        </>
      ),
    },

    {
      title: "Phone",
      dataIndex: "phonenumber",

      render: (phonenumber) => (
        <small className="text-muted d-flex align-items-center mt-1">
          <a
            href={`tel:${phonenumber}`}
            className="text-decoration-none text-muted"
          >
            <i className="fa-solid fa-phone text-success me-2"></i>
            <span>{phonenumber || "N/A"}</span>
          </a>

          <a
            href={`https://wa.me/${phonenumber?.replace(/\D/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="ms-3"
            title="Chat on WhatsApp"
          >
            <i
              className="fa-brands fa-whatsapp text-success"
              style={{ fontSize: "16px" }}
            ></i>
          </a>
        </small>
      ),
    },

    {
      title: "Groups",
      dataIndex: "CustomerGroups",
      width: 180,

      render: (groups) =>
        groups?.length ? (
          <div className="d-flex flex-column gap-1">
            {groups.map((group) => (
              <div key={group.Id} className="small text-dark">
                <i className="fa-solid fa-circle fa-2xs text-info me-2"></i>
                <span title={group.Name}>
                  {group.Name?.length > 25
                    ? `${group.Name.slice(0, 25)}...`
                    : group.Name}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <span className="text-muted">N/A</span>
        ),
    },
    {
      title: "Date",
      dataIndex: "createdDate",
      render: (date) => {
        if (!date) {
          return (
            <span className="text-muted">
              <i className="fa-regular fa-calendar-xmark me-2"></i>
              N/A
            </span>
          );
        }

        return (
          <span>
            <i className="fa-regular fa-calendar me-2 text-primary"></i>
            {dayjs(date).isValid() ? dayjs(date).format("DD/MM/YYYY") : date}
          </span>
        );
      },
    },
    {
      title: "Renewal",
      dataIndex: "renewalDate",

      render: (date) => {
        if (!date) {
          return (
            <span className="text-muted">
              <i className="fa-regular fa-calendar-xmark me-2"></i>
              N/A
            </span>
          );
        }

        const renewal = dayjs(date);

        if (!renewal.isValid()) {
          return <span>{date}</span>;
        }

        const days = renewal.startOf("day").diff(dayjs().startOf("day"), "day");

        return (
          <>
            <div>
              <i className="fa-regular fa-calendar me-2 text-danger"></i>
              {renewal.format("DD/MM/YYYY")}
            </div>

            <small
              className={
                days < 0
                  ? "text-danger"
                  : days <= 30
                    ? "text-danger"
                    : "text-success"
              }
            >
              <i className="fa-regular fa-clock me-2"></i>
              {days < 0
                ? `${Math.abs(days)} days overdue`
                : `${days} days left`}
            </small>
          </>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <>
          {/* <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v btn border" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                to={`/crm/customerinfo/${record.customerId}`}
                className="dropdown-item"
              >
                <Eye className="info-img text-info" />
                View
              </Link>
            </li>
            <li>
              <Link
                to={`/crm/customerinfo/${record.customerId}?edit=true`}
                className="dropdown-item"
                // onClick={() => setEditObj(record)}
              >
                <Edit className="me-2 text-secondary" />
                Edit
              </Link>
            </li>
          </ul> */}
          <div className="d-flex align-items-center gap-2">
            <div className="action-table-data">
              <div className="edit-delete-action ">
                <Link
                  to={`/crm/customerinfo/${record.customerId}?edit=true`}
                  className="me-2 p-2 shadow-sm"
                  title="Edit"
                  // onClick={() => setEditObj(record)}
                >
                  <i className="ti ti-pencil text-primary"></i>
                </Link>
              </div>
            </div>
            <div className="action-table-data">
              <div className="user-delete-action ">
                <Link
                  to={`/crm/customerinfo/${record.customerId}`}
                  state={{ selectedTab: "Contacts" }}
                  className="me-2 p-2 shadow-sm"
                  title="create contact "
                  // onClick={() => setEditObj(record)}
                >
                  <i className="ti ti-user text-success"></i>
                </Link>
              </div>
            </div>

            <Switch
              checked={record.active === 1}
              title={record.active === 1 ? "Inactive" : "Active"}
              size="small"
              onChange={(checked) => handleStatusChange(record, checked)}
            />
          </div>
        </>
      ),
    },
  ];

  const getCustomerCount = async () => {
    try {
      const response = await axios.get(
        `${BASE_CRM_URL}customers/GetCustomersCounts`,
      );

      if (response.data.Status) {
        setCardData(response.data.ResultData[0]);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No leadcount data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("leadcount API Error:", error);
    }
  };

  const getCustomers = async (active = "", renewal = "") => {
    setLoading(true);

    try {
      let url = `${BASE_CRM_URL}customers/GetCustomers`;

      const params = [];

      if (active !== "") {
        params.push(`active=${active}`);
      }

      if (renewal) {
        params.push(`renewal=${renewal}`);
      }

      if (params.length > 0) {
        url += `?${params.join("&")}`;
      }

      const response = await axios.get(url);

      if (response.data.Status) {
        setCustomerData(response.data.ResultData || []);
      } else {
        setCustomerData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (record, checked) => {
    try {
      setLoading(true);

      const response = await axios.post(
        `${BASE_CRM_URL}customers/UpdateCustomerStatus`,
        {
          id: record.customerId,
          active: checked ? 1 : 0,
        },
      );

      if (response.data?.Status) {
        // Immediately update UI
        setCustomerData((prevCustomerData) =>
          prevCustomerData.map((customer) =>
            customer.customerId === record.customerId
              ? { ...customer, active: checked ? 1 : 0 }
              : customer,
          ),
        );

        Swal.fire({
          icon: "success",
          title: "Success",
          text: checked
            ? "customer activated successfully"
            : "customer deactivated successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        getCustomerCount();
        getCustomers();
      }
    } catch (error) {
      console.error("Status update error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update customer status",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCustomers();
    getCustomerCount();
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  // const renderRefreshTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Refresh
  //   </Tooltip>
  // );

  const exportCustomerExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Customers");

      // Columns
      worksheet.columns = [
        {
          header: "Company",
          key: "company",
          width: 30,
        },
        {
          header: "Phone Number",
          key: "phonenumber",
          width: 18,
        },
        {
          header: "Country",
          key: "country",
          width: 12,
        },
        {
          header: "City",
          key: "city",
          width: 18,
        },
        {
          header: "ZIP",
          key: "zip",
          width: 12,
        },
        {
          header: "State",
          key: "state",
          width: 18,
        },
        {
          header: "Address",
          key: "address",
          width: 35,
        },
        {
          header: "Website",
          key: "website",
          width: 30,
        },
        {
          header: "Active",
          key: "active",
          width: 12,
        },
        {
          header: "Renewal Date",
          key: "renewalDate",
          width: 20,
        },
        {
          header: "Created Date",
          key: "createdDate",
          width: 22,
        },
      ];

      // Add data
      customerData.forEach((customer) => {
        worksheet.addRow({
          company: customer.company ?? "",
          phonenumber: customer.phonenumber ?? "",
          country: customer.country ?? "",
          city: customer.city ?? "",
          zip: customer.zip ?? "",
          state: customer.state ?? "",
          address: customer.address ?? "",
          website: customer.website ?? "",

          active:
            customer.active === 1
              ? "Active"
              : customer.active === 0
                ? "Inactive"
                : "",

          renewalDate: customer.renewalDate
            ? new Date(customer.renewalDate).toLocaleDateString("en-IN")
            : "",

          createdDate: customer.createdDate
            ? new Date(customer.createdDate).toLocaleString("en-IN")
            : "",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(1);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      headerRow.height = 22;

      // Borders and alignment
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            wrapText: true,
          };
        });
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header on every printed page
      worksheet.printTitlesRow = "1:1";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate Excel
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Customers.xlsx");
    } catch (error) {
      console.error("Customer Excel export error:", error);

      Swal.fire("Error", "Failed to generate Customer Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportCustomerPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "Company",
        "Phone",
        "Country",
        "City",
        "ZIP",
        "State",
        "Address",
        "Website",
        "Active",
        "Renewal Date",
        "Created Date",
      ];

      const rows = customerData.map((customer) => [
        customer.company ?? "",
        customer.phonenumber ?? "",
        customer.country ?? "",
        customer.city ?? "",
        customer.zip ?? "",
        customer.state ?? "",
        customer.address ?? "",
        customer.website ?? "",

        customer.active === 1
          ? "Active"
          : customer.active === 0
            ? "Inactive"
            : "",

        customer.renewalDate
          ? new Date(customer.renewalDate).toLocaleDateString("en-IN")
          : "",

        customer.createdDate
          ? new Date(customer.createdDate).toLocaleString("en-IN")
          : "",
      ]);

      // Report title - top center
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("Customer Report", 148, 12, {
        align: "center",
      });

      // Generated On - top right
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn}`, 291, 12, {
        align: "right",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 20,

        margin: {
          top: 20,
          bottom: 18,
          left: 6,
          right: 6,
        },

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        // Footer
        didDrawPage: () => {
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Get total pages
      const totalPages = doc.internal.getNumberOfPages();

      // Page X of Y
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("Customers.pdf");
    } catch (error) {
      console.error("Customer PDF export error:", error);

      Swal.fire("Error", "Failed to generate Customer PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };
  return (
    <div className="page-wrapper">
      {exportLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <div className="content">
        <div className="d-flex justify-content-between mb-3">
          {/* Left section with heading and description */}
          <div className="d-flex flex-column">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/crm/dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item " aria-current="page">
                  Customers
                </h4>
              </ol>
            </nav>
            <p className="text-muted">
              Manage and add new customers to your database
            </p>
          </div>
          <div className="d-flex justify-content-end align-items-center gap-3 mb-3 flex-wrap">
            {/* Icon List */}
            <ul className="d-flex align-items-center list-unstyled m-0 p-0 table-top-head">
              <li className="me-2">
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={exportCustomerPDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li className="me-2">
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link onClick={exportCustomerExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              {/* <li className="d-none">
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li> */}
            </ul>

            {/* Buttons */}
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <Link
                className="btn btn-success btn-sm"
                onClick={() => setShowCustomer(true)}
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>

              {/* <Link to="/crm/contacts" className="btn btn-primary text-white">
                <i className="ti ti-user me-1"></i>
                Contacts
              </Link> */}
            </div>
          </div>
        </div>
        <div className="row">
          {/* Total Customers */}
          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div
              className="card revenue-widget flex-fill shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => getCustomers()}
            >
              <div
                className="card-body d-flex justify-content-between align-items-center  py-2 px-3"
                style={{ minHeight: "55px" }}
              >
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h3 className="mb-0 fw-bold">{cardsData?.TotalClients}</h3>
                  <p className=" fw-semibold">Total</p>
                </div>

                <div
                  className=" rounded-circle revenue-icon bg-primary-subtle text-primary d-flex align-items-center  justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-users fs-16"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Active Customers */}
          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div
              className="card revenue-widget flex-fill shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => getCustomers(1)}
            >
              <div
                className="card-body d-flex justify-content-between align-items-center py-2 px-3"
                style={{ minHeight: "55px" }}
              >
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h3 className="mb-0 fw-bold">{cardsData?.ActiveClients}</h3>
                  <p className="mb-0 fw-semibold">Active </p>
                </div>

                <div
                  className="rounded-circle revenue-icon bg-success-subtle text-success d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-circle-check fs-16"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Inactive Customers */}
          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div
              className="card revenue-widget flex-fill shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => getCustomers(0)}
            >
              <div
                className="card-body d-flex justify-content-between align-items-center py-2 px-3"
                style={{ minHeight: "55px" }}
              >
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h3 className="mb-0 fw-bold">{cardsData?.InactiveClients}</h3>
                  <p className="mb-0 fw-semibold">Inactive </p>
                </div>

                <div
                  className="rounded-circle revenue-icon bg-secondary-subtle text-secondary d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-user-slash fs-16"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Reminders / Renewals */}
          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div
              className="card revenue-widget flex-fill shadow-sm"
              style={{ cursor: "pointer" }}
              onClick={() => getCustomers("", today)}
            >
              <div
                className="card-body d-flex justify-content-between align-items-center py-2 px-3"
                style={{ minHeight: "55px" }}
              >
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h3 className="mb-0 fw-bold">
                    {cardsData?.thisWeekRenewals}
                  </h3>
                  <p className="mb-0 fw-semibold">Renewals</p>
                </div>

                <div
                  className="rounded-circle revenue-icon bg-warning-subtle text-warning d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-bell fs-16"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card table-list-card" style={{ marginTop: "-1rem" }}>
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set p-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="dropdown me-2">
                {/* <Link
                  to="#"
                  className="btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#add-units"
                >
                  <i className="ti ti-filter me-1"></i>
                </Link> */}
              </div>
            </div>
          </div>

          <div className="card-body p-0">
            <div className="table-responsive">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={customerData} />
              )}
            </div>
          </div>
        </div>
      </div>
      <>
        <NewCustomer
          show={showCustomer}
          onClose={() => setShowCustomer(false)}
          getCustomers={getCustomers}
        />
        <CommonFooter />
      </>
    </div>
  );
};

export default CRMCustomers;
